<template>
  <transition name="move">
    <div v-dragWhole v-show="isShow" class="camera-timeline">
      <!-- 镜头时间块 -->
      <div class="lens-content" v-for="(c, i) in lensPart" :style="{left: secondWidth*c.start + 'px', width: secondWidth*(c.dura || 0.5) + 'px'}">
        <div v-if="i!==0" class="drag-left" :data-action="'left-' + i"></div>
        <div v-if="i!==0" class="drag-right" :data-action="'right-' + i"></div>
        <div class="camera-name" :data-action="'move-' + i" :class="{active: i===lensIndex}">{{i===0?'默认镜头':'镜头'+i}}</div>
        <div class="camera-add" :style="{right:-(secondWidth +34)/4+ 'px'}" @click.self="addCamera(i)">+</div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: 'cameraTime',
  data() {
    return {
      ANALYSIS: {
        add : {category:'camera_track', action:'click_insert_camera', label:'镜头特效_添加镜头'},
        del : {category:'camera_track', action:'click_delete_camera', label:'镜头特效_删除镜头'},
        move : {category:'camera_track', action:'drag_camera', label:'镜头特效_移动镜头'},
        change : {category:'camera_track', action:'drag_change_camera_len', label:'镜头特效_改变镜头长度'},
      },
      isShow: false,
      timelineWidth: 0, // 时间轴的长度
      secondWidth: 0, // 一秒钟的长度
      lensPart: [], // 镜头的时间对象
      dragHandle: false, // 是否拖动中
      mpos: null, // mousedown 保留的属性集合
      action: '', // 拖动的动作
    }
  },
  props: ["totalTime"],
  computed: {
    ...mapGetters([
      "Tool_Size",
      "TOOL",
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "lensEditState",
      "lensIndex",
      "cameras"
    ])
  },
  watch: {
    lensEditState(val, oldVal) {
      if(val) {
        this.isShow = true;
        this.$store.commit('toggle_shortcutType', 'camera');
        this.initData();
      } else {
        this.$store.commit('toggle_shortcutType', 'editor');
        this.isShow = false;
      }
    },
    totalTime() {
      this.isShow && this.initData()
    },
    'SelectScenes_Msg.id' () {
      this.isShow && this.$store.commit('toggle_lensEditState', false);
    },
    "Tool_Size.width" (val, oldval) {
      // 根据画布的尺寸改变时间轴尺寸
      this.styleWidth()
    },
    "TOOL.optimized" () {
      this.isShow && this.initData()
    }
  },
  mounted() {
    this.$bus.on('camera_delete', () => {
      this.delCamera()
    })
    this.$bus.on('keycode_delete', data => {
      if(this.isShow && this.lensIndex > 0) {
        this.delCamera(this.lensIndex)
      }
    })
    this.$bus.on('undoRedoHandle', (data) => {
      // 撤销和恢复的事件
      if(data.type === 'camera_add' || data.type === 'camera_delete' || data.type === 'camera_changeTime') {
        this.initData();
      }
    })
  },
  methods: {
    initData() {
      // 数据初始化
      let part = null;
      this.$store.commit('toggle_cameras', this.SelectScenes_Msg.camera.cameras);
      this.lensPart = [];
      for(let i in this.cameras) {
        part = {
          start: this.cameras[i].animations.delay,
          dura: this.cameras[i].animations.duration
        }
        part.end = part.start + part.dura
        /*
         * 不够显示会被直接覆盖掉，所以无须判断
          if(i > this.cameras.length-1) {
            if(part.end < this.cameras[i+1].animations.delay - 0.5) {
              part.add = true;
            }else {
              part.add = false;
            }
          }else {
            if(part.end < this.totalTime - 0.5) {
              part.add = true;
            }else {
              part.add = false;
            }
          }
        */
        this.lensPart.push(part)
      }
      this.styleWidth()
    },
    styleWidth() {
      // 时间轴变化对应的变化
      this.timelineWidth = this.Tool_Size.width - 84;
      this.secondWidth = this.timelineWidth / this.totalTime
    },
    dragDown(dis, action) {
      this.dragHandle = false
      if(!action) return;
      let actionS = action.split('-');
      this.$store.commit('toggle_lensIndex', + actionS[1]);
      if(actionS[1] === "0") return;
      let m = null;
      this.action = actionS[0];
      m = this.lensPart[this.lensIndex]
      this.mpos = {
        x: dis.x,
        l: m.start,
        r: m.end,
        d: m.dura
      }
      // 获取限制 ml左边限制, mr右边限制
      if(this.action === 'move') {
        this.mpos.ml = this.lensPart[this.lensIndex-1].end;
        if(this.lensIndex < this.cameras.length-1) {
          this.mpos.mr = this.lensPart[this.lensIndex+1].start;
        } else {
          this.mpos.mr = this.totalTime;
        }
        this.$analysis(this.ANALYSIS.move)
      }else if(this.action === 'left') {
        this.mpos.ml = this.lensPart[this.lensIndex-1].end;
        this.mpos.mr = m.end - 0.5;
        this.$analysis(this.ANALYSIS.change)
      }else if(this.action === 'right') {
        this.mpos.ml = m.start + 0.5;
        if(this.lensIndex < this.cameras.length-1) {
          this.mpos.mr = this.lensPart[this.lensIndex+1].start;
        } else {
          this.mpos.mr = this.totalTime;
        }
        this.$analysis(this.ANALYSIS.change)
      }
      this.mpos.undoData = {
        scenesId: this.SelectScenes_Msg.id,
        cameraIndex: this.lensIndex,
        reData: Object.assign({}, this.cameras[this.lensIndex].animations)
      }
    },
    dragMove(pos) {
      this.dragHandle = true;
      if(!this.action) return;
      let change = Math.round((pos.x - this.mpos.x)/this.secondWidth*2) * 0.5;
      let cl=0, cr=0;
      cl = this.mpos.l + change;
      cr = this.mpos.r + change;
      this.mpos.change = change;
      if(this.action === 'move') {
        if(cl < this.mpos.ml) {
          cl = this.mpos.ml;
          cr = cl + this.mpos.d
        }
        if(cr > this.mpos.mr) {
          cr = this.mpos.mr;
          cl = cr - this.mpos.d
        }
      }else if(this.action === 'left') {
        cr = this.mpos.r;
        if(cl < this.mpos.ml) {
          cl = this.mpos.ml;
        }else if(cl > this.mpos.mr) {
          cl = this.mpos.mr
        }
      }else if(this.action === 'right') {
        cl = this.mpos.l;
        if(cr < this.mpos.ml) {
          cr = this.mpos.ml;
        }else if(cr > this.mpos.mr) {
          cr = this.mpos.mr
        }
      }
      this.lensPart[this.lensIndex].start = cl;
      this.lensPart[this.lensIndex].end = cr;
      this.lensPart[this.lensIndex].dura = cr - cl
    },
    dragUp() {
      let change = this.mpos ? this.mpos.change : 0;
      this.action = '';
      if(!this.dragHandle) {
        this.mpos = null;
        return;
      }
      this.dragHandle = false;
      // 没有变化,不处理
      if(change) {
        this.cameras[this.lensIndex].animations = {
          delay: this.lensPart[this.lensIndex].start,
          duration: this.lensPart[this.lensIndex].dura
        }
        this.mpos.undoData.data = Object.assign({}, this.cameras[this.lensIndex].animations)
        this.SelectScenes_Msg.camera.updateCamera(this.lensIndex, {
          animations: this.cameras[this.lensIndex].animations
        })
        eve("undo_redo", null, {
          type: 'camera_changeTime', 
          data: this.mpos.undoData
        })
      }
      this.mpos = null;
    },
    middleClick(dis, action) {
      // 鼠标中键(删除)
      this.dragHandle = false
      if(!action) return;
      let actionS = action.split('-');
      if(actionS[1] === "0") return;
      this.delCamera(+actionS[1])
    },
    rightClick(dis, action) {
      // 鼠标右键
      this.dragHandle = false
      if(!action) return;
      let actionS = action.split('-');
      if(actionS[1] === "0") return;
      this.$store.commit('toggle_lensIndex', + actionS[1]);
      this.$bus.emit('FeaturesPop_vue',{
				name : 'timelineRightKey',
        type : 1,
        initialX : dis.x+2,
				initialY : dis.y+2,
      });
    },
    addCamera(i) {
      // 添加镜头
      let exitTime = 0,
          delay = 0,
          duration = 1;

      // 几种时间空隙下的添加
      if(this.lensPart[i+1]) {
        exitTime = this.lensPart[i+1].start - this.lensPart[i].end
      }else {
        exitTime = this.totalTime - this.lensPart[i].end
      }
      if(exitTime >= 1.5) {
        delay = this.lensPart[i].end + 0.5;
      }else if(exitTime >= 1) {
        delay = this.lensPart[i].end;
      }else if(exitTime >= 0.5) {
        delay = this.lensPart[i].end;
        duration = 0.5
      } else {
        return;
      }
      this.SelectScenes_Msg.camera.addCamera({animations:{delay: delay, duration: duration}}, i+1)
      eve("undo_redo", null, {
        type: 'camera_add', 
        data: {
          scenesId: this.SelectScenes_Msg.id,
          cameraIndex: i+1,
          data: $.extend(true, {}, this.SelectScenes_Msg.camera.cameras[i+1])
        }
      })
      this.initData()
      this.$store.commit('toggle_lensIndex', -1);
      this.$store.commit('toggle_cameras', this.SelectScenes_Msg.camera.cameras);
      this.$analysis(this.ANALYSIS.add)
    },
    delCamera(i) {
      // 删除场景页(删除后默认没有选中任何镜头)
      if(!i) {
        i = this.lensIndex
      }
      eve("undo_redo", null, {
        type: 'camera_delete', 
        data: {
          scenesId: this.SelectScenes_Msg.id,
          cameraIndex: i,
          reData: $.extend(true, {}, this.SelectScenes_Msg.camera.cameras[i]),
          scale: this.TOOL.scale
        }
      })
      this.SelectScenes_Msg.camera.delCamera(i)
      this.$store.commit('toggle_lensIndex', -1);
      this.$store.commit('toggle_cameras', this.SelectScenes_Msg.camera.cameras);
      this.initData()
      this.$analysis(this.ANALYSIS.del)
    }
  }
}
</script>
<style lang="scss" scoped>
.camera-timeline {
  position: absolute;
  width: 100%;
  height: 30px;
  bottom: 0;
  background: #fff;
  overflow: hidden;
}
.lens-content {
  position: absolute;
  top: 4px;
  height: 22px;
}
.camera-name {
  width: 100%;
  height: 100%;
  line-height: 20px;
  border-radius: 5px;
  color: #fff;
  background-color: #5778fb;
  border:1px solid #5778fb;
  overflow: hidden;

  &:hover {
    background-color: #87A0FC;
    border-color: #1338CE;
  }
}
.camera-name.active {
  background-color: #1338CE;
  border-color: #1338CE;
}
.camera-add {
  position: absolute;
  width:17px;
  height: 17px;
  top: 3px;
  right: -17px;
  line-height: 16px;
  border-radius: 5px;
  color: #fff;
  background-color: #5778fb;
  font-weight: bold;
  cursor: pointer;
}

.drag-left,.drag-right {
  position: absolute;
  height: 22px;
  top: 0;
  width: 5px;
  opacity: 0;
  cursor: ew-resize;
}
.drag-left {
  left: 0;
}
.drag-right {
  right: 0;
}


.move-enter-active {
  animation: move-in .2s ease-in-out;
}
.move-leave-active {
  animation: move-in .2s ease-in-out reverse;
}
@keyframes move-in {
  0% {
    height: 0;
  }
  100% {
    height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/timeline/cameraTime.vue